export default __webpack_public_path__ + "static/char-03-anr-21ff1b0dd573dab2a21f57bd7b5349cf.gif";